import { render, staticRenderFns } from "./d-book-mark-as-spam.vue?vue&type=template&id=992a525a&"
import script from "./d-book-mark-as-spam.vue?vue&type=script&lang=js&"
export * from "./d-book-mark-as-spam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports